'use client'

import { Button } from '@tebuto/buttons/Button'
import { useComponentTranslation } from '@tebuto/functions/translation.components'
import { useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'

export default function PreviewBanner() {
    const { t } = useComponentTranslation()
    const [showPreview, setShowPreview] = useState<boolean>(false)
    const searchParams = useSearchParams()

    useEffect(() => {
        if (searchParams.has('preview')) {
            setShowPreview(true)
        }
    }, [searchParams])

    if (showPreview) {
        return (
            <div className="fixed right-0 bottom-0 p-4 z-50">
                <div className="bg-primary-600 h-full rounded-lg px-8 py-4 flex justify-between gap-4 flex-wrap items-center shadow border border-primary-500">
                    <p className="text-primary-100 text-sm">{t('directory.previewTitle')}</p>
                    <Button
                        href={`${process.env.NEXT_PUBLIC_APP_BASE_URL}/einstellungen/account/praxis`}
                        outline
                        color="white"
                        className="md:w-max"
                    >
                        {t('directory.backToSettings')}
                    </Button>
                </div>
            </div>
        )
    }

    return <></>
}
